import * as React from 'react';
import { Menu } from 'antd';

type SubMenuProps = {
  children: React.ReactElement[] | React.ReactElement;
};

const SubMenu = (props: SubMenuProps & React.ComponentProps<typeof Menu.SubMenu>) => {
  return <Menu.SubMenu {...props} className="sub-menu" />;
};

export default SubMenu;
